let scroll_bar_width = getScrollbarWidth();
let scroll_bar_half_width = scroll_bar_width/2;

/*wp.domReady(() => {
    document.addEventListener("click", (event) => {
        if (event.target.classList.contains("switch-to-edit")) {
            const blockEditor = wp.data.dispatch("core/block-editor");
            const selectedBlock = wp.data.select("core/block-editor").getSelectedBlock();

            if (selectedBlock) {
                blockEditor.updateBlockAttributes(selectedBlock.clientId, { mode: "edit" });
            }
        }
    });
});*/

jQuery('body').css('--scroll-bar-half-width', scroll_bar_half_width + 'px');
jQuery(document).ready(function() {
    initGallery();
    addClassHoverCardClickable();
    changeLinkAxeptio();
    readMore();
    removePaddingSameSectionBackground();
    scrollTop();
    scrollStickyHeader();
    toggleAccordion();
    triggerClick();
    flash_info_init();
});

function addClassHoverCardClickable(){
    if(jQuery('.pgut-clickable').length > 0){
        // mouseup plutôt que click pour le clic roulette
        jQuery('.pgut-clickable').mouseup(function(e){
            e.preventDefault();
            // Si on clique sur un sous-menu sans lien ou le ul du sous-menu, on ouvre/ferme le sous-menu en question
            if((jQuery(this).hasClass('wp-block-navigation-item') && jQuery(this).hasClass('has-child')) || jQuery(this).hasClass('wp-block-navigation__submenu-container')){
                var element = jQuery(this);
                if(jQuery(this).hasClass('wp-block-navigation__submenu-container')){
                    var element = jQuery(this).parent();
                }
                if(!element.find('a').eq(0).attr("href") || element.find('a').eq(0).attr("href") == "#"){
                    e.preventDefault();
                    var expanded = element.find('button.wp-block-navigation-submenu__toggle').attr('aria-expanded');
                    if(expanded === "true"){
                        expanded = false
                    }
                    else {
                        expanded = true;
                    }
                    element.find('button.wp-block-navigation-submenu__toggle').attr('aria-expanded',expanded);
                }
                else {
                    window.location.href = jQuery(this).find('a').eq(0).attr("href");
                }
            }
            else {
                if(e.which == 1){
                    // Pour ouvrir dans un nouvel onglet
                    if(jQuery(this).find('a').eq(0).attr("target") == "_blank" ){
                        window.open(jQuery(this).find('a').eq(0).attr("href"));
                    }
                    else {
                        window.location.href = jQuery(this).find('a').eq(0).attr("href");
                    }
                }
                else if(e.which == 2){
                    window.open(jQuery(this).find('a').eq(0).attr("href"));
                }
            }

            e.stopPropagation();
        });
    }
}

/*
 * Implémentation du bouton "readmore"
 */
function readMore(action = 'hide') {
    let elements = jQuery('.js-read-more');

    if (action === 'hide') {
        elements.each(function () {
            let parent = jQuery(this).parent();
            let read_content = parent.nextAll().detach();
            let content_block = jQuery(this).closest('.wp-block-group').find('.js-read-more-content').appendTo(parent.parent());
            read_content.appendTo(content_block);
        });
    }

    elements.click(function (e) {
        e.preventDefault();

        let tl = gsap.timeline();
        tl.to(jQuery(this).parent(), {ease: 'power0', opacity: 0, overflow: 'hidden', display: 'none'});
        tl.to(jQuery(this).parent().next(), {
            ease: 'power0', opacity: 1, height: 'auto', onComplete: function () {
                ScrollTrigger.refresh();
            }
        });
    });
}

function getScrollbarWidth() {

    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

// Scroll to top of the page
function scrollTop(){
    jQuery('.nr-scroll-top').click(function(){
        jQuery('html, body').animate({scrollTop: '0px'}, 500);
    });
}

function scrollStickyHeader(){
    /* Au scroll, montrer ou cacher header topbar */
    jQuery(window).scroll(function(){
        if(jQuery(document).scrollTop() > 300){
            jQuery('header').addClass('pgut-sticky-header');
        }
        else if(jQuery(document).scrollTop() <= 300){
            if(jQuery('header').hasClass('pgut-sticky-header')){
                jQuery('header').removeClass('pgut-sticky-header');
            }
        }
    });
}

function changeLinkAxeptio(){
    if(jQuery('a[href="#manage-axeptio"]').length > 0){
        jQuery('a[href="#manage-axeptio"]').attr('href', 'javascript:openAxeptioCookies()');
    }
}

// Block Accordion - Open / Close
function toggleAccordion() {
    if(jQuery('.pgut-accordion__tab .pgut-accordion__heading').length > 0){
        var accordion_headings = jQuery('.pgut-accordion__tab .pgut-accordion__heading');
        accordion_headings.on('click', function(){
            jQuery(this).parent().toggleClass('pgut-accordion__is-open');
        })
    }
}

// Rendre un élément cliquable alors qu'il ne possède un lien que sur une petite zone
function triggerClick() {
    if(jQuery('.pgut-clickable').length > 0){
        jQuery('.pgut-clickable').mouseenter(function(e){
            jQuery(this).find('.pgut-button').addClass('pgut-button__hover');
        });

        jQuery('.pgut-clickable').mouseleave(function(e){
            jQuery(this).find('.pgut-button').removeClass('pgut-button__hover');
        });

        // mouseup plutôt que click pour le clic roulette
        jQuery('.pgut-clickable').mouseup(function(e){
            if(e.which == 1){
                // Pour ouvrir dans un nouvel onglet
                if(jQuery(this).find('a').eq(0).attr("target") == "_blank" ){
                    window.open(jQuery(this).find('a').eq(0).attr("href"));
                }
                else {
                    window.location.href = jQuery(this).find('a').eq(0).attr("href");
                }
            }
            else if(e.which == 2){
                window.open(jQuery(this).find('a').eq(0).attr("href"));
            }
        });
    }
}

function removePaddingSameSectionBackground(){
    // Si les deux sections l'une à la suite de l'autre ont le même background
    // on enlève un padding
    jQuery('main *:not(.is-layout-grid) > .wp-block-group.has-background').each(function() {
        let $current = jQuery(this);
        let $prev = $current.prev('*:not(.is-layout-grid) > .wp-block-group.has-background');

        // Vérifier si l'élément précédent existe et a une classe
        if ($prev.length && $prev.attr('class')) {
            let currentClasses = $current.attr('class').split(' ');
            let prevClasses = $prev.attr('class').split(' ');

            let currentBackgroundClass = currentClasses.find(c => c.includes('has-') && c.includes('-background-color'));
            let prevBackgroundClass = prevClasses.find(c => c.includes('has-') && c.includes('-background-color'));

            // Appliquer le style si les deux éléments ont une classe de fond correspondante
            if (currentBackgroundClass && prevBackgroundClass && currentBackgroundClass === prevBackgroundClass) {
                $current.css('padding-top', '0').addClass('pgut-has-background--no-padding-top');
            }
        }
    });

    // Si les deux sections l'une à la suite de l'autre n'ont pas de background toutes les deux
    // on enlève un padding
    jQuery('main *:not(.is-layout-grid) > .wp-block-group').each(function() {
        let $current = jQuery(this);
        let $prev = $current.prev('*:not(.is-layout-grid) > .wp-block-group');

        // Vérifier si l'élément précédent existe et a une classe
        if ($prev.length && $prev.attr('class')) {
            let currentClasses = $current.attr('class').split(' ');
            let prevClasses = $prev.attr('class').split(' ');
            let currentBackgroundClass = currentClasses.find(c => c.includes('has-') && c.includes('-background-color'));
            let prevBackgroundClass = prevClasses.find(c => c.includes('has-') && c.includes('-background-color'));

            // Appliquer le style si les deux éléments ont une classe de fond correspondante
            if (!currentBackgroundClass && !prevBackgroundClass) {
                $current.css('padding-top', '0');
            }
        }
    });
}

function initGallery(){
    if(jQuery('.pgut-gallery').length > 0){
        if(jQuery('.pgut-gallery__image').length > 0){
            jQuery('.pgut-gallery__image').on('click', function(){
                jQuery('.pgut-gallery__image__selected').removeClass('.pgut-gallery__image__selected');
                jQuery(this).addClass('pgut-gallery__image__selected');

                var src = jQuery(this).attr('src');
                jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);
            });

            jQuery('.pgut-gallery__arrow-prev').on('click', function(){
                var current_selected_img = jQuery('.pgut-gallery__image__selected');
                if(current_selected_img.prev().length > 0){
                    var offset = current_selected_img.prev().position();
                    var scroll_left = jQuery('.pgut-gallery__thumbnails').scrollLeft();

                    jQuery('.pgut-gallery__thumbnails').scrollLeft(offset.left + scroll_left);

                    current_selected_img.removeClass('pgut-gallery__image__selected');
                    current_selected_img.prev().addClass('pgut-gallery__image__selected');

                    var src = current_selected_img.prev().attr('src');
                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);
                }
            });

            jQuery('.pgut-gallery__arrow-next').on('click', function(){
                var current_selected_img = jQuery('.pgut-gallery__image__selected');
                if(current_selected_img.next().length > 0){
                    var offset = current_selected_img.next().offset();
                    var scroll_left = jQuery('.pgut-gallery__thumbnails').scrollLeft();

                    jQuery('.pgut-gallery__thumbnails').scrollLeft(offset.left + scroll_left);

                    current_selected_img.removeClass('pgut-gallery__image__selected');
                    current_selected_img.next().addClass('pgut-gallery__image__selected');

                    var src = current_selected_img.next().attr('src');
                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);
                }

            });
        }
    }
}

function flash_info_init(){
    let $flash_infos = jQuery('.pgut-flash-info');
    if( $flash_infos.length > 0 ){

        $flash_infos.each(function () {
            let $element = jQuery(this);
            let $prev_btn= $element.find('.pgut-flash-info__prev-btn');
            let $next_btn= $element.find('.pgut-flash-info__next-btn');
            let $close_btn= $element.find('.pgut-flash-info__close-btn');
            let $list = $element.find('.pgut-flash-info__list');
            let $items = $list.find('.pgut-flash-info__list__item');
            let $flash_info_init_auto_id = null;

            if( $items.length > 0 ){
                let $transition = $list.attr('data-delay');
                if( $transition > 0){
                    $transition = $transition * 1000;
                    $flash_info_init_auto_id = setInterval( flash_info_init_auto, $transition, $element);
                }
            }

            if( $close_btn.length > 0){
                let $ID= $close_btn.attr('data-cookie');
                let $delay= $close_btn.attr('data-time');

                // vérification du délai de fermeture
                let match = document.cookie.match(new RegExp('(^| )' + $ID + '=([^;]+)'));
                if (match) {
                    $element.hide();
                    clearInterval($flash_info_init_auto_id);
                    $flash_info_init_auto_id = null;
                    return;
                }

                $close_btn.on('click', function(){
                    $element.fadeOut();
                    $flash_info_init_auto_id = null;

                    // cookie de fermeture
                    let $minutes = $delay;
                    let $now = new Date();
                    let $time = $now.getTime();
                    $time += $minutes * 60 * 1000;
                    $now.setTime($time);
                    document.cookie = $ID+'=hidden; expires=' + $now.toUTCString() +'; path=/';
                });
            }

            if( $next_btn.length > 0){
                $next_btn.on('click', function(){
                    let $active_item = $list.find('.pgut-flash-info__list__item.js-active');
                    let $next = $active_item.next('.pgut-flash-info__list__item');

                    $active_item.removeClass('js-active');
                    $next.addClass('js-active');

                    if( $prev_btn.length > 0) {
                        $prev_btn.removeClass('pgut-flash-info__nav__disabled');
                    }

                    $next = $next.next('.pgut-flash-info__list__item');
                    if( $next.length < 1){
                        $next_btn.addClass('pgut-flash-info__nav__disabled');
                    }

                    clearInterval($flash_info_init_auto_id);
                    $flash_info_init_auto_id = null;
                });
            }

            if( $prev_btn.length > 0){
                $prev_btn.on('click', function(){
                    let $active_item = $list.find('.pgut-flash-info__list__item.js-active');
                    let $prev = $active_item.prev('.pgut-flash-info__list__item');

                    $active_item.removeClass('js-active');
                    $prev.addClass('js-active');

                    if( $next_btn.length > 0) {
                        $next_btn.removeClass('pgut-flash-info__nav__disabled');
                    }

                    $prev = $prev.prev('.pgut-flash-info__list__item');
                    if( $prev.length < 1){
                        $prev_btn.addClass('pgut-flash-info__nav__disabled');
                    }

                    clearInterval($flash_info_init_auto_id);
                    $flash_info_init_auto_id = null;
                });
            }
        });

    }
}

function flash_info_init_auto( $element ){
    let $prev_btn= $element.find('.pgut-flash-info__prev-btn');
    let $next_btn= $element.find('.pgut-flash-info__next-btn');
    let $list = $element.find('.pgut-flash-info__list');

    let $active_item = $list.find('.pgut-flash-info__list__item.js-active');
    let $next = $active_item.next('.pgut-flash-info__list__item');

    if( $next.length < 1){
        $next = $list.find('.pgut-flash-info__list__item:first-child');
    }

    $active_item.removeClass('js-active');
    $next.addClass('js-active');

    $active_item = $next;
    $prev = $active_item.prev('.pgut-flash-info__list__item');
    $next = $active_item.next('.pgut-flash-info__list__item');

    $prev_btn.removeClass('pgut-flash-info__nav__disabled');
    $next_btn.removeClass('pgut-flash-info__nav__disabled');

    if( $prev.length < 1){
        $prev_btn.addClass('pgut-flash-info__nav__disabled');
    }
    if( $next.length < 1){
        $next_btn.addClass('pgut-flash-info__nav__disabled');
    }
}
